import React, { FC } from 'react';
import { Checkbox as AntdCheckbox, FormInstance } from 'antd';
import { CheckboxProps as AntdCheckboxProps, CheckboxChangeEvent } from 'antd/lib/checkbox'; // Import CheckboxChangeEvent

export const Checkbox: FC<any> = ({ onChange, ...restProps }) => {
  // Pass the checked value directly to the onChange prop
  // This is typically what Ant Design Form.Item expects

  const handleInternalChange = (e: CheckboxChangeEvent) => {
    // Use CheckboxChangeEvent
    const { checked } = e.target;
    // Call the original onChange handler if it exists
    if (onChange) {
      onChange(checked);
    }
  };

  return (
    <AntdCheckbox
      {...restProps}
      onChange={handleInternalChange}
      defaultChecked={restProps?.checked !== undefined ? restProps.checked : restProps?.value}
    />
  );
};

export default Checkbox;
